export default __webpack_public_path__ + "static/media/0aa29eeca761fb1083587ae33944dede.jpg";